import firedux from '../firedux'
import store from '../store'

import {PRESENCE_ENDPOINT} from '../../config/constants'

export default (presence, uid) => {
  const state = store.getState()

  if (!uid) uid = state.getIn(['currentUser', 'uid'])

  console.log('setting current user presence', presence, uid, state.getIn(['currentUser', 'uid']))

  if (!uid) return

  const ENDPOINT = `${PRESENCE_ENDPOINT}/${uid}`
  firedux.ref.child(ENDPOINT).set(presence)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/current_user_presence.js
 **/